import { Modal } from '@smartgift/frontend-toolkit';
import React from 'react';

import * as S from './style';

export function IllustrationModal({ content, ...rest }) {
  return (
    <Modal size="sm" {...rest}>
      <S.IllustrationModal>
        <S.Content>{content}</S.Content>
      </S.IllustrationModal>
    </Modal>
  );
}
